import { FieldTypes } from '../../constants'
import { addFieldRow } from '../../fields'
import {
  BooleanField,
  DropdownField,
  FieldMap,
  MultipleSelectField,
  NumberField,
} from '../../types'
import { FHRAction, FHRCategory, FHRDeceleration, FHRMethod, FHRVariability } from '../types'

const baselineBpmField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'Baseline BPM',
  unit: 'bpm',
  min: 60,
  max: 240,
}

const variabilityField: DropdownField<FHRVariability> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Variability',
  inputType: 'radio',
  options: [
    { text: 'Absent', id: FHRVariability.ABSENT },
    { text: 'Minimal (≤5 bpm)', id: FHRVariability.MINIMAL },
    { text: 'Moderate (6–25 bpm)', id: FHRVariability.MODERATE },
    { text: 'Marked (>25 bpm)', id: FHRVariability.MARKED },
  ],
}

const accelerationsField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Accelerations Present',
  inputType: 'radio',
  yesText: 'Yes',
  noText: 'No',
}

const decelerationsField: DropdownField<FHRDeceleration> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Decelerations',
  inputType: 'radio',
  options: [
    { text: 'None', id: FHRDeceleration.NONE },
    { text: 'Early', id: FHRDeceleration.EARLY },
    { text: 'Variable', id: FHRDeceleration.VARIABLE },
    { text: 'Late', id: FHRDeceleration.LATE },
    { text: 'Prolonged', id: FHRDeceleration.PROLONGED },
  ],
}

const categoryField: DropdownField<FHRCategory> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Category',
  inputType: 'radio',
  options: [
    { text: 'Category I (Normal)', id: FHRCategory.I },
    { text: 'Category II (Indeterminate)', id: FHRCategory.II },
    { text: 'Category III (Abnormal)', id: FHRCategory.III },
  ],
}

const methodField: DropdownField<FHRMethod> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Monitoring Method',
  inputType: 'radio',
  options: [
    { text: 'Doppler', id: FHRMethod.DOPPLER },
    { text: 'Fetoscope', id: FHRMethod.FETOSCOPE },
    { text: 'Internal Scalp Electrode', id: FHRMethod.INTERNAL_SCALP_ELECTRODE },
  ],
}

const actionsField: MultipleSelectField = {
  type: FieldTypes.MULTIPLE_SELECT,
  placeholder: 'Interventions Taken',
  optional: true,
  condition: v =>
    v?.decelerations === FHRDeceleration.LATE ||
    v?.decelerations === FHRDeceleration.VARIABLE ||
    v?.decelerations === FHRDeceleration.PROLONGED,
  options: [
    { text: 'Position Change', id: FHRAction.POSITION_CHANGE },
    { text: 'Oxygen', id: FHRAction.OXYGEN },
    { text: 'Fluid Bolus', id: FHRAction.FLUID_BOLUS },
    { text: 'IV Access', id: FHRAction.IV_ACCESS },
    { text: 'Notify Provider', id: FHRAction.NOTIFY_PROVIDER },
    { text: 'Amnioinfusion', id: FHRAction.AMNIOINFUSION },
  ],
}

export const fhrField: FieldMap = {
  name: 'Fetal Heart Rate',
  children: {
    baselineBpm: addFieldRow(baselineBpmField, { index: 0, flex: 1 }),
    method: addFieldRow(methodField, { index: 0, flex: 1 }),
    variability: addFieldRow(variabilityField, { index: 1, flex: 1 }),
    decelerations: addFieldRow(decelerationsField, { index: 1, flex: 1 }),
    accelerations: addFieldRow(accelerationsField, { index: 2, flex: 1 }),
    category: addFieldRow(categoryField, { index: 2, flex: 1 }),
    actions: actionsField,
  },
}
